import Headroom from 'headroom.js'
import $ from 'jquery'

export default function initHeadroom(){
  const theHeader = document.querySelector('.js-header')
  const headroom = new Headroom(theHeader, { offset: 0, tolerance: 0 })
  headroom.init()
}
